import styled from 'styled-components';

export const SkillsSvgStyled = styled.div`
    width: 100%;
    max-width: 380px;
    margin: auto;

    svg {
        width: 100%;
    }
    #eponxbav0kri29_to {
        animation: eponxbav0kri29_to__to 4000ms linear infinite normal forwards
    }
    @keyframes eponxbav0kri29_to__to {
        0% {
            transform: translate(0px,0px)
        }
        12.500000% {
            transform: translate(-34.384350px,0px)
        }
        15% {
            transform: translate(30.227860px,0px)
        }
        17.500000% {
            transform: translate(-13.817712px,0px)
        }
        20% {
            transform: translate(18.636716px,0px)
        }
        22.500000% {
            transform: translate(0px,0px)
        }
        100% {
            transform: translate(0px,0px)
        }
    }
    #eponxbav0kri30_to {
        animation: eponxbav0kri30_to__to 4000ms linear infinite normal forwards
    }
    @keyframes eponxbav0kri30_to__to {
        0% {
            transform: translate(0px,0px)
        }
        12.500000% {
            transform: translate(52.233005px,0px)
        }
        15% {
            transform: translate(-27.105280px,0px)
        }
        17.500000% {
            transform: translate(23.315776px,0px)
        }
        20% {
            transform: translate(-16.513168px,0px)
        }
        22.500000% {
            transform: translate(0px,0px)
        }
        100% {
            transform: translate(0px,0px)
        }
        
`